// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import Vue from 'vue'
import 'es6-promise/auto';
import App from './layouts/App'
import router from './router'
import axios from 'axios'
import VueCookies from 'vue-cookies'
import VueI18n from "vue-i18n"
import messages from '@/locales'
import VueMeta from 'vue-meta'

import '@/assets/css/fonts.css'
import '@/assets/css/reset.css'
// import '@/assets/css/install.css'

import "@/assets/bootstrap-5.1.3-dist/css/bootstrap.min.css"
import "@/assets/bootstrap-5.1.3-dist/js/bootstrap.min.js"

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(VueCookies)
Vue.use(VueI18n)
Vue.use(VueMeta)

/* eslint-disable no-new */
const i18n = new VueI18n({
  locale: 'ko',
  messages
})

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js